(() => {
  const initialize = root => {
    root.querySelectorAll('[data-condition-dialog]').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      const option = dialog.closest('[data-condition-option]');
      const trigger = option?.querySelector('[data-condition-open]');
      if (!trigger) return;
      dialog.dataset.initialized = 'true';
      const sync = () => {
        const selected = option.querySelector('input[data-option-position]:checked, select[data-option-position]')?.value;
        dialog.querySelectorAll('[data-condition-value]').forEach(card => {
          const active = card.dataset.conditionValue === selected;
          card.toggleAttribute('data-selected', active);
          card.querySelector('[data-condition-selected]').hidden = !active;
        });
      };
      trigger.addEventListener('click', () => { sync(); if (!dialog.open) dialog.showModal(); });
      option.addEventListener('change', sync);
      dialog.querySelector('[data-condition-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href]'));
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
